import React, { useEffect, useState } from "react";
import c from "./Clock.module.scss";


interface IProps {
  children?: React.ReactNode;
}

const Clock: React.FC<IProps> = (props) => {
  const [time, setTime] = useState<Date>(new Date());

  useEffect(() => {
    const interval: number = window.setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  const hours: string = time.getHours().toString().padStart(2, "0");
  const minutes: string = time.getMinutes().toString().padStart(2, "0");

  return (
    <div className={c.clock}>
      {hours}:{minutes}
    </div>
  );
};

export default Clock;